export default class PaginationRequest {
  /**
 * Create a pagination request.
 *
 * @param {number} pageNumber
 * @param {number} pageSize
 * @param {Array} [filters]
 */
  constructor (pageNumber, pageSize, filters) {
    this.pageNumber = pageNumber
    this.pageSize = pageSize
    this.filters = Array.isArray(filters) ? filters : []
  }

  /**
 * Get params for request.
 *
 * @return {object}
 */
  getParams () {
    const params = {
      pagenumber: this.pageNumber,
      pagesize: this.pageSize
    }

    this.filters.filter(filter => filter.hasValue()).forEach(filter => {
      params[filter.property.toLowerCase()] = filter.value.toLowerCase ? filter.value.toLowerCase() : filter.value
    })

    return params
  }
}
